function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9.778,
  cy: 9.778,
  r: 9.778,
  fill: "#BAD8E6",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.833,
  cy: 12.833,
  r: 5.5,
  fill: "#F1F4F7",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009FE4",
  d: "M19.14 5.304c-3.815-3.813-10.02-3.813-13.836 0-3.813 3.815-3.813 10.022 0 13.836 3.814 3.813 10.02 3.813 13.835 0 3.815-3.815 3.815-10.021 0-13.836zm-3.46 10.377l-2.766-2.768-3.458 3.46-1.383-1.384 3.458-3.459-2.767-2.767h6.916v6.918z"
}));

function SvgTransferIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer-icon.e3cc34da.svg";
export { ForwardRef as ReactComponent };